import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';

import { FullLayout_ROUTES } from './shared/routes/full-layout.routes';
import { CommonLayout_ROUTES } from './shared/routes/common-layout.routes';
import { TermsConditionsComponent } from './authentication/terms-conditions/terms-conditions.component';

const appRoutes: Routes = [
  { path: '', redirectTo: '/authentication/login-1', pathMatch: 'full' },
  {
      path: '',
      redirectTo: '/authentication/login-1',
      pathMatch: 'full',
  },
  {
    path: 'pages/terms-conditions',
    component: TermsConditionsComponent,
    data: {
      title: 'Termos de uso',
    }
  },
  {
      path: '',
      component: CommonLayoutComponent,
      children: CommonLayout_ROUTES
  },
  {
      path: '',
      component: FullLayoutComponent,
      children: FullLayout_ROUTES
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
  },
];
@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            useHash: true,
            // preloadingStrategy: PreloadAllModules,
            // anchorScrolling: 'enabled',
            // scrollPositionRestoration: 'enabled',
        })
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutingModule {
}
